interface StatCardProps {
	label: string;
	value: string | number;
}

export function StatCard({ label, value }: StatCardProps) {
	return (
		<div className="p-4 rounded-2xl bg-surface border border-border-subtle">
			<div className="text-[11.5px] text-text-muted uppercase tracking-wider font-medium">
				{label}
			</div>
			<div
				className="mt-1.5 text-[26px] font-light tabular-nums text-text-primary"
				style={{ letterSpacing: "-0.02em" }}
			>
				{value}
			</div>
		</div>
	);
}
